<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <loading :active.sync="loadingCal" :can-cancel="false" :is-full-page="true"></loading>
    
        <!-- <div class="titulo">
            <button aria-label="Previous week" class="vuecal__arrow vuecal__arrow--prev" v-on:click="cambiarAnteriorSemana()">&nbsp;<i class="angle"></i>&nbsp;
            </button>
            <span>{{semana.numeroSemana}}</span>
            <button aria-label="Next week" class="vuecal__arrow vuecal__arrow--next" v-on:click="cambiarSiguienteSemana()">&nbsp;<i class="angle"></i>&nbsp;
            </button>
        </div> -->
    
        <table style="width: 100%">
            <tr>
                <th></th>
                <th v-for="diaSemana in semana.dias" v-bind:key="diaSemana.diaNumero">
                    {{diaSemana.diaEtiqueta}}
                </th>
            </tr>
    
            <tr>
                <th></th>
                <th v-for="diaSemana in semana.dias" v-bind:key="diaSemana.diaNumero">
                    <table style="width: 100%;border:solid 1px;">
                        <tr>
                            <td v-for="numeroSala in casillasSalas" v-bind:key="numeroSala" :style="anchoCalendario">
                                <div :style="anchoCalendario">
                                    <div class="titulo-sala" :style="anchoCalendario">{{numeroSala}}</div>
                                </div>
                            </td>
                            <td :style="anchoCalendario">
                                <div :style="anchoCalendario">
                                    <div class="titulo-sala" :style="anchoCalendario">E1</div>
                                </div>
                            </td>
                            <td :style="anchoCalendario">
                              <div :style="anchoCalendario">
                                <div class="titulo-sala" :style="anchoCalendario">E2</div>
                              </div>
                            </td>
                        </tr>
                    </table>
                </th>
            </tr>
    
            <tr v-for="hora in semana.horas" v-bind:key="hora.posicion" class="casilla horas" :style="estiloLineaHora(hora)">
                <td>{{hora.horaEtiqueta}}</td>
    
                <td v-for="(casilla, indexCasilla) in casillas[hora.posicion]" v-bind:key="casilla.diaSemana"
                    :class="[indexCasilla%2 === 0 ? 'agenda-calendario-dia-par' : 'agenda-calendario-dia-impar', casilla.esfechaActual?'agenda-calendario-dia-actual':'']">
                    <div>
                        <table width="100%">
                            <tr>
                                <td v-for="sala in casilla.salas" v-bind:key="sala.numeroSala" :style="anchoCalendario"
                                    class="agenda-calendario-sala">
                                    <div v-if="sala.idBloque != null" :style="idEspecialidadFiltro==null || (sala.idEspecialidad === idEspecialidadFiltro) ? 'background-color:'+sala.color+'; border: 1px solid #b5179e;' : ''"
                                         @click.self="crearCitaDesdeCalendario(casilla, sala)"
                                         @contextmenu.prevent.self="llamarMenuCasilla($event, {sala:sala, casilla: casilla})">
                                      <span style="display: none">id agenda empleado {{sala.idAgendaEmpleado}}</span>
                                      <sala-calendario :style="anchoCalendario"
                                                    @asignarHoraLlegadaPaciente="asignarHoraLlegadaPaciente"
                                                    @obtenerSemana="obtenerSemana"
                                                     @consultarDetalle="consultarDetalle"
                                                     :numeroSala="sala.numeroSala" :cita="sala.cita"
                                                     :idEspecialidadFiltro="idEspecialidadFiltro"
                                                     :forzarMostradoEspecialidad="idEspecialidadFiltro==null || sala.idEspecialidad === idEspecialidadFiltro"
                                                     @mostrarDetalle="mostrarDetalle"/>
                                    </div>
                                    <div v-else :style="idEspecialidadFiltro==null || (sala.idEspecialidad === idEspecialidadFiltro) ? 'background-color:'+sala.color : ''"
                                         @click.self="crearCitaDesdeCalendario(casilla, sala)"
                                         @contextmenu.prevent.self="llamarMenuCasilla($event, {sala:sala, casilla: casilla})">
                                      <span style="display: none">id agenda empleado {{sala.idAgendaEmpleado}}</span>
                                      <sala-calendario :style="anchoCalendario"
                                                    @asignarHoraLlegadaPaciente="asignarHoraLlegadaPaciente"
                                                    @obtenerSemana="obtenerSemana"
                                                     @consultarDetalle="consultarDetalle"
                                                     :numeroSala="sala.numeroSala" :cita="sala.cita"
                                                     :idEspecialidadFiltro="idEspecialidadFiltro"
                                                     :forzarMostradoEspecialidad="idEspecialidadFiltro==null || sala.idEspecialidad === idEspecialidadFiltro"
                                                     @mostrarDetalle="mostrarDetalle"/>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </td>
            </tr>
        </table>
    
        <vue-context ref="menuCalendario" v-if="activarSobreAsignarDoctor">
    
          <li slot-scope="child">
            <a href="#" @click.prevent="sobreAsignarDoctorSala($event.target.innerText, child.data)">Sobre asignar</a>
          </li>
    
        </vue-context>
    
        <b-modal v-model="showDialogIniciarSession" id="modIniciarSesion" title="¿Deseas iniciar la sesión?" scrollable>
    
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(iniciarSesionServ)">
                    <validation-provider name="ReqHerr" :rules="{ required: true }" v-slot="validationContext" v-if="!citaSeleccionada.pacienteEsNino && (!citaSeleccionada.especialistaNino && !citaSeleccionada.citaEmbajador && noExistePTIVigente)">
                        <label>¿Requiere herramientas?</label><validacion/>
                        <b-form-group>
    
                            <v-select style="width: 100%" :clearable="false" :options="listaSINO" v-model="datosIniciarSesion.herramientas" :reduce="(variable) => variable.valor" label="etiqueta" placeholder="¿La sesión requiere herramientas?" id="idReqHerramientas" name="nmReqHerramientas">
                                <span slot="no-options">No hay valores disponibles</span>
                            </v-select>
                            <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '" />
                        </b-form-group>
                    </validation-provider>
    
                    <validation-provider name="MotReqHerr" :rules="{ required: true }" v-slot="validationContext" v-if="!datosIniciarSesion.herramientas && !citaSeleccionada.especialistaNino && !citaSeleccionada.citaEmbajador && noExistePTIVigente">
                        <label>Motivo para no requerir herramientas</label><validacion/>
                        <b-form-group>
    
                            <v-select style="width: 100%" :clearable="false" :options="listaMotivosHerramientas" v-model="datosIniciarSesion.idMotivoHerramienta" :reduce="(variable) => variable.id" label="nombre" placeholder="Motivo para no requerir herramientas" id="idMotReqHerramientas" name="nmMotReqHerramientas">
                                <span slot="no-options">No hay valores disponibles</span>
                            </v-select>
                            <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '" />
                        </b-form-group>
                    </validation-provider>
    
                    <validation-provider name="ReqHerr" :rules="{ required: true }" v-slot="validationContext" v-if="listaPlanesPaciente !== undefined && listaPlanesPaciente.length > 0">
                        <label>Plan del paciente</label><validacion/>
                        <b-form-group :state="planPacienteState" invalid-feedback="El plan del paciente es requerido">
                            <v-select style="width: 100%" :clearable="false" :options="listaPlanesPaciente" v-model="datosIniciarSesion.idPlan" :reduce="(variable) => variable.id" label="nombre" placeholder="Selecciona una plan" id="idPlanPac">
                                <span slot="no-options">No hay planes disponibles</span>
                            </v-select>
                        </b-form-group>
                        <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '" />
                    </validation-provider>
    
                    <validation-provider name="ReqHerr" :rules="{ required: true }" v-slot="validationContext" v-if="listaKitsCita !== undefined && listaKitsCita.length > 0">
                        <label>Kit del tratamiento de la cita</label><validacion/>
                        <b-form-group :state="kitTratamientoCita" invalid-feedback="El kit es requerido">
                            <v-select style="width: 100%" :clearable="false" :options="listaKitsCita" v-model="datosIniciarSesion.idKit" :reduce="(variable) => variable.id" label="nombre" placeholder="Selecciona una kit" id="idKitTratCita">
                                <span slot="no-options">No hay kits disponibles</span>
                            </v-select>
                        </b-form-group>
                        <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '" />
                    </validation-provider>
    
                    <b-button ref="submitIniciarSesion" type="submit" style="visibility: hidden"></b-button>
    
                </b-form>
            </validation-observer>
    
            <template v-slot:modal-footer>
                <b-spinner small v-if="loadingExistePTI"></b-spinner>
                <b-button variant="outline-primary" @click="submitIniciarSesion" v-if="!loadingExistePTI">Aceptar</b-button>
                <b-button variant="outline-danger" @click="showDialogIniciarSession = false">Cancelar
                </b-button>
            </template>
    
        </b-modal>
    
        <b-modal v-model="showDialogConfirmarCita" id="modConfirmarCita" title="¿Deseas confirmar la cita?" scrollable>
            <template v-slot:modal-footer>
                <b-button variant="outline-primary" @click="submitConfirmarCita">Aceptar</b-button>
                <b-button variant="outline-danger" @click="showDialogConfirmarCita = false">Cancelar
                </b-button>
            </template>
    
        </b-modal>
    
        <b-modal  size="lg" v-model="showDialogCancelarCita" id="modCancelarCita"  title="¿Deseas cancelar la cita?" scrollable>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(cancelarCitaServ)">
    
                    <validation-provider name="MotCancelar" :rules="{ required: true }" v-slot="validationContext">
                        <label>Motivo de cancelación</label><validacion/>
                        <b-form-group>
                            <v-select style="width: 100%" :options="listaMotivosCancelacion"
                                      v-model="datosCancelarCita.motivoCancelacion"
                                      :reduce="(variable) => variable.id"
                                      label="descripcion" placeholder="Selecciona el motivo de cancelación" >
                                <span slot="no-options">No hay valores disponibles</span>
                            </v-select>
                            <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '" />
                        </b-form-group>
                    </validation-provider>
    
                    <validation-provider name="DescCancelar" :rules="{ required: true }" v-slot="validationContext">
                        <label>Descripción de cancelación</label><validacion/>
                        <b-form-group>
                            <b-textarea v-model="datosCancelarCita.descripcionCancelacion" placeholder="Descripción de cancelación"></b-textarea>
                            <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '" />
                        </b-form-group>
                    </validation-provider>
    
                    <b-button ref="submitCancelarCita" type="submit" style="visibility: hidden"></b-button>
                </b-form>
            </validation-observer>
            <template v-slot:modal-footer>
                <b-button variant="outline-primary" @click="submitCancelarCita">Aceptar</b-button>
                <b-button variant="outline-danger" @click="showDialogCancelarCita = false">Cancelar
                </b-button>
            </template>
    
        </b-modal>
    
    </div>
    </template>
    
    <script>
    
    export default {
        name: "CalendarioDentalia",
        components: {
            // SalaCalendario
        },
        props: {
            idEspecialidadFiltro: Number,
            listaMotivosHerramientas: Array,
            listaMotivosCancelacion: Array,
            listaKitsPacienteNuevo: Array
        },
        data: () => ({
          version: process.env.VUE_APP_ENV_VERSION,
          debug: false,
            anchoCalendario: "width:30px;",
            activarSobreAsignarDoctor: false,
            loadingCal: false,
            numeroSalas: undefined,
            dias: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
            semana: {},
            casillas: [],
            fechaInicio: undefined,
            fechaFin: undefined,
    
            citaSeleccionada: Object,
            showDialogIniciarSession: false,
            ogCabecera: null,
            listaOGCabecera: [],
    
            cargandoKitsCita: false,
            listaKitsCita: [],
    
            listaPlanesPaciente: [],
            listaSINO: [{
                etiqueta: "SI",
                valor: true
            }, {
                etiqueta: "NO",
                valor: false
            }],
    
            datosIniciarSesion: {},
            datosCancelarCita: {},
    
            reqHerState: null,
            planPacienteState: null,
            kitTratamientoCita: null,
            kitPacienteNuevo: null,
    
            showDialogConfirmarCita: false,
            showDialogCancelarCita: false,
            showDialogReasignarCita: false,
            datosCita: null,
    
            casillasSalas: [],
            horariosDoctor: Array,
    
            noExistePTIVigente: false,
            loadingExistePTI: false,
        }),
        computed: {
    
        },
        created() {
          this.activarSobreAsignarDoctor = this.$localStorageService.can('RD_01_sobreasignar');
          this.debug = this.$localStorageService.getDebug();
        },
        methods: {
            calcularAnchoCalendario(numeroSalas) {
              if (numeroSalas <= 4) {
                this.anchoCalendario = "width:30px;";
              } else {
                this.anchoCalendario = "width:" + (130 / (numeroSalas + 2)) + "px; font-size:8px;";
              }
            },
            horarioDoctor(casilla, numeroSala) {
              const indiceCasilla = this.$moment(casilla.fechaCasilla).format('YYYY/MM/DD') + '-' + casilla.horaCasilla1 + '-' + (numeroSala);
    
              let horarioDoctor = null;
    
              const indiceCasilla1 = (indiceCasilla+'-5');
              if (this.horariosDoctor[indiceCasilla1] !== undefined) {
                horarioDoctor = this.horariosDoctor[indiceCasilla1];
              } else if (this.horariosDoctor[indiceCasilla] !== undefined) {
                horarioDoctor = this.horariosDoctor[indiceCasilla];
              }
    
                return horarioDoctor;
            },
            especialidadHorarioDoctor(casilla, numeroSala) {
                const horarioDoc =  this.horarioDoctor(casilla, numeroSala);
                if (horarioDoc === null) {
                    return null;
                }
    
                return horarioDoc.idEspecialidad;
            },
            pintarEventos(val, horariosDoctor) {

            //  let posicion = Array();
            //  const horaActual = new Intl.DateTimeFormat(undefined, { timeStyle: "short" }).format(new Date());
    
                this.horariosDoctor = horariosDoctor;
                this.semana.horas.forEach(hora => {
                  /*if (hora.horaEtiqueta > horaActual){
                    posicion.push(hora.posicion)

                  }*/
                    this.casillas[hora.posicion].forEach(casilla => {
                        casilla.salas.forEach(sala => {
    
                            let citasNormal = undefined;
    
                            let indiceCasilla = this.$moment(casilla.fechaCasilla).format('YYYY/MM/DD')+'-'+casilla.horaCasilla1 +'-'+ (sala.numeroSala);
    
                            if (val[indiceCasilla] !== undefined) {
                              citasNormal = val[indiceCasilla];
                            }
    
                            if (horariosDoctor[indiceCasilla] !== undefined) {
                                sala.idAgendaEmpleado = horariosDoctor[indiceCasilla].idAgendaEmpleado
                                sala.color = horariosDoctor[indiceCasilla].colorEspecialidad;
                                sala.idEspecialidad = horariosDoctor[indiceCasilla].idEspecialidad;
                                sala.idBloque = horariosDoctor[indiceCasilla].idBloque;
                                if(horariosDoctor[indiceCasilla].idBloque != null){
                                    sala.color = sala.color + 'border: 1px solid black;'
                                }
                            }
    
                            if(citasNormal !== undefined) {
                              sala.cita = citasNormal;
                            }
                        })
                    })
                });

             /* this.semana.horas.forEach(h => {
                if (posicion[0] == h.posicion){
                  h.linea = 1;
                }
              })*/

                this.casillasSalas = Array();
    
                let contador = 1;
                for (let i = 0; i < this.numeroSalas; i++) {
                    this.casillasSalas.push(contador++);
    
                    if (contador > this.numeroSalas) {
                        contador = 1;
                    }
                }
            },
    
            cambiarAnteriorSemana() {
                let fecha = new Date(this.fechaInicio);
                fecha.setDate(fecha.getDate() - 7);
                this.$emit("seleccionarFecha", fecha);
            },
    
            cambiarSiguienteSemana() {
                let fecha = new Date(this.fechaInicio);
                fecha.setDate(fecha.getDate() + 7);
                this.$emit("seleccionarFecha", fecha);
            },
            obtenerSalas(salas){
                this.numeroSalas = salas
            },
    
            calcularSemana(fechaRecibida, eventos, horariosDoctor, numero) {
                let fecha = new Date();
                fecha = new Date(fechaRecibida.toISOString());
                

                this.numeroSalas = numero;
    
                this.calcularAnchoCalendario(numero);
    
                this.semana = {};
    
                const mesSemana = this.$moment(fecha.toISOString()).format('MMMM YYYY');
                //
                // const fechaSemana = this.$moment(fecha).format('WW');
                // let numeroSemana = fechaSemana.week();
    
                this.semana.numeroSemana = "Semana " + this.$moment(fecha.toISOString()).week()  + " (" + mesSemana.charAt(0).toUpperCase() + mesSemana.slice(1) + ")";
    
                this.semana.dias = Array();
                fecha.setDate((fecha.getDate() - fecha.getDay()));
    
                this.fechaInicio = this.$moment(fecha.toISOString()).format('YYYY/MM/DD');
                this.llenarCasillas(fecha);

                for (let i = 0; i < 7; i++) {
    
                    this.semana.dias.push({
                        fecha: new Date(fecha),
                        diaEtiqueta: this.dias[fecha.getDay()] + " " + this.$moment(fecha.toISOString()).format('DD') + " de " +  this.$moment(fecha.toISOString()).format('MMM'),
                        diaNumero: fecha.getDay()
                    });
                    fecha.setDate(fecha.getDate() + 1);
                }
    
                this.fechaFin = this.$moment(fecha.toISOString()).format('YYYY/MM/DD');
                let semana = this.semana.numeroSemana
                this.pintarEventos(eventos, horariosDoctor);
                this.obtenerSemana(semana)
                
            },
    
            calcularHoras() {
                this.semana.horas = Array();
                let fecha = new Date();
                fecha.setHours(7);
                fecha.setMinutes(0);
                fecha.setMilliseconds(0);
    
                for (let i = 0; i < 69; i++) {
                    this.semana.horas.push({
                     /* linea: 0,*/
                        posicion: i,
                        horaEtiqueta: this.$moment(fecha.toISOString()).format('HH:mm'),
                        horaEtiqueta1: this.$moment(fecha.toISOString()).format('HHmm'),
                    });
                    fecha.setMinutes(fecha.getMinutes() + 15);
                }
    
            },
    
            llenarCasillas(fechaInicio) {
                this.calcularHoras();
                this.casillas = Array();
    
                const diaActual = this.$moment().format('YYYY-MM-DD');
    
                this.semana.horas.forEach(horaSemana => {
                    const fechaCasilla = new Date();
                    fechaCasilla.setTime(fechaInicio.getTime());
                    const casillas = Array();
                    for (let i = 0; i < 7; i++) {
    
                        const fechaCasillaFormato = this.$moment(fechaCasilla.toISOString()).format('YYYY-MM-DD');
    
                        casillas.push({
                            diaSemana: i,
                            horaCasilla: horaSemana.horaEtiqueta,
                            horaCasilla1: horaSemana.horaEtiqueta1,
                            fechaCasilla: fechaCasillaFormato,
                            esfechaActual:  fechaCasillaFormato === diaActual,
                            salas: this.llenarSalas()
                        });
    
                        fechaCasilla.setDate(fechaCasilla.getDate() + 1);
                    }
    
                    this.casillas.push(casillas);
                });
    
            },
    
            llenarSalas() {
                const salas = Array();
                for (let i = 0; i < this.numeroSalas; i++) {
                    salas.push({
                        numeroSala: i + 1,
                        cita: undefined,
                        color: "inherit"
                    })
                }
                salas.push({
                    numeroSala: 100,
                    cita: undefined,
                    color: "inherit"
                })
    
                salas.push({
                  numeroSala: 101,
                  cita: undefined,
                  color: "inherit"
                })
    
                return salas;
            },
            obtenerSemana(semana){
                this.$emit("obtenerSemana", semana); 
            },
            asignarHoraLlegadaPaciente(datosCita){ 
                this.$emit("asignarHoraLlegadaPaciente", datosCita); 
            },
            validarTomaHerramientas() {
              this.loadingExistePTI = true;
              this.noExistePTIVigente = true;
              const parametros = {idPaciente: this.citaSeleccionada.idPaciente}
              this.$http
                  .post(this.$api + "pti/existePtiMayor6Meses", parametros)
                  .then((response) => {
                    this.noExistePTIVigente = response.data.data;
                    this.datosIniciarSesion.herramientas = this.noExistePTIVigente;
                  })
                  .catch((error) => {
                    console.error(
                        "Error al obtener la validacion de existencia de un pti del  del paciente: " +
                        error
                    );
                  })
                  .finally(() => {
                    this.loadingExistePTI = false;
                    if (this.citaSeleccionada.especialistaNino) {
                      this.datosIniciarSesion.herramientas = false;
                    }
                  });
            },
    
            submitIniciarSesion() {
                this.$refs.submitIniciarSesion.click();
            },
            submitCancelarCita() {
                this.$refs.submitCancelarCita.click();
            },
    
            iniciarSesionServ() {
                this.showDialogIniciarSession = false;
                this.datosIniciarSesion.citaSeleccionada = this.citaSeleccionada;
                this.$emit("iniciarSesion", this.datosIniciarSesion);
            },
    
            consultarDetalle(cita) {
                this.$emit("consultarDetalle", JSON.parse(JSON.stringify(cita)));
            },
    
            confirmarCita(cita) {
                this.showDialogConfirmarCita = true;
                this.datosCita = JSON.parse(JSON.stringify(cita));
            },
            cancelarCita(cita) {
                this.showDialogCancelarCita = true;
                this.datosCita = JSON.parse(JSON.stringify(cita));
                this.datosCancelarCita = {
                    idCita: this.datosCita.idCita,
                    idUsuario: this.$localStorageService.getIdUsuario(),
                    motivoCancelacion: undefined,
                    descripcionCancelacion: undefined
                };
            },
            reagendarCita(cita) {
                this.datosCita = JSON.parse(JSON.stringify(cita));
                this.$emit("reagendarCita", this.datosCita);
            },
            submitConfirmarCita() {
                this.$emit("confirmarCita", this.datosCita.idCita);
            },
            cancelarCitaServ() {
                this.$emit("cancelarCita", this.datosCancelarCita);
            },
            crearCitaDesdeCalendario(casilla, sala) {

                if (this.$localStorageService.can('CA_06_crear_cita') && sala.cita === undefined
                    && this.$moment(casilla.fechaCasilla + ' ' +casilla.horaCasilla) >= this.$moment()) {
    
                    const horarioDoctor = this.horarioDoctor(casilla, sala.numeroSala);
                    if (horarioDoctor !== null) {
                        const datosAgregar = {
                            sillon: horarioDoctor.sillon,
                            idEmpleado: horarioDoctor.idEmpleado,
                            idEspecialidad: horarioDoctor.idEspecialidad,
                            fechaCita: casilla.fechaCasilla,
                            hora: casilla.horaCasilla.substring(0, 2),
                            minuto: casilla.horaCasilla.substring(3, 5)
                        };
    
                        this.$emit("crearCitaDesdeCalendario", datosAgregar);
                    }
                }
            },
            reasignarDoctor(cita) {
              this.datosCita = JSON.parse(JSON.stringify(cita));
              this.$emit("reasignarDoctor", this.datosCita);
            },
    
            llamarMenuCasilla($event, datos) {
              if(datos.sala.cita === undefined && datos.sala.cita1 === undefined
                  && this.$moment(datos.casilla.fechaCasilla + ' ' +datos.casilla.horaCasilla) >= this.$moment()) {
               this.$refs.menuCalendario.open($event, datos);
              }
            },
    
            sobreAsignarDoctorSala(event, data) {
              const datos = {
                fechaCita: data.casilla.fechaCasilla,
                horaInicio: data.casilla.horaCasilla1.substr(0, 2),
                minutoInicio: data.casilla.horaCasilla1.substr(2, 3),
                horaFin: data.casilla.horaCasilla1.substr(0, 2),
                minutoFin: data.casilla.horaCasilla1.substr(2, 3),
                sillon: data.sala.numeroSala
              }
              this.$emit("sobreAsignarDoctor", datos);
            },
            sobreAsignarDoctor(cita) {
              this.datosCita = JSON.parse(JSON.stringify(cita));
              const datos = {
                fechaCita: cita.fechaCitaSinZona,
                horaInicio: cita.horaInicio.substr(0, 2),
                minutoInicio: cita.horaInicio.substr(2, 3),
                horaFin: cita.horaFin.substr(0, 2),
                minutoFin: cita.horaFin.substr(2, 3),
                sillon: cita.sillon
              }
              this.$emit("sobreAsignarDoctor", datos);
            },
            estiloLineaHora(hora) {
              if (hora === undefined || hora === null || hora.horaEtiqueta === undefined || hora.horaEtiqueta === null) {
                return "";
              }
              const cadenas = hora.horaEtiqueta.split(":");
              if (cadenas[1] === "00") {
                return "border-top-width: 2px;border-top-color: #939393;";
              }
    
              return "";
            },
            mostrarDetalle(cita) {
              this.$emit("mostrarDetalle", cita);
            }
        }
    };
    </script>
    
    <!-- Add "scoped" attribute to limit CSS to this component only -->
    
    <style scoped>
    .titulo {
        background-color: rgba(0, 0, 0, .1);
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        text-align: center;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        font-size: 1.4em;
        line-height: 1.3;
        min-height: 2em;
        width: 100%;
        user-select: none;
    }
    
    .titulo span {
        position: relative;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
    }
    
    button:not(:disabled),
    [type="button"]:not(:disabled),
    [type="reset"]:not(:disabled),
    [type="submit"]:not(:disabled) {
        cursor: pointer;
    }
    
    .horas {
        color: #c9c9c9;
    }
    
    .casilla {
        border: #c9c9c9 solid 1px;
        height: 20px;
    }
    .casillaBlue {
      border: 1px solid  #c9c9c9;
      border-bottom: rgba(65, 103, 248, 0.78) solid 3px ;
      height: 20px;
    }
    </style>
    